var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',{attrs:{"transform":"translate(-28 -156) translate(0 151) translate(28 5)"}},[_c('circle',{attrs:{"cx":"12","cy":"12","r":"4.5"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }